import styles from "./TagsCustom.module.scss";
import { useEffect, useRef, useState } from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";

export const TagsCustom = ({ value, tags, cssClass, onChange }) => {
  const inputClass = [styles.input];
  if (cssClass?.input) {
    inputClass.push(cssClass.input);
  }
  const [items, setItems] = useState([]);
  const [find, setFind] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    setItems(value);
  }, [value]);

  const searchTag = (q) => {
    setQ(q);
    if (q !== "") {
      setFind(
        tags.filter((tag) => tag.text.toLowerCase().includes(q.toLowerCase())),
      );
    } else {
      setFind([]);
    }
  };

  const addTag = (tag) => {
    setItems([...items, tag]);
    onChange([...items, tag]);
    setFind([]);
    setQ("");
  };

  const addWord = () => {
    setItems([...items, { id: q, text: q }]);
    onChange([...items, { id: q, text: q }]);
    setFind([]);
    setQ("");
  };

  const removeTag = (item) => {
    const _tags = items.filter((tag) => tag.id !== item.id);
    setItems(_tags);
    onChange(_tags);
    setFind([]);
    setQ("");
  };

  const SortableItem = SortableElement(({ item }) => {
    return (
      <li className={"tagClass"}>
        <span>{item.text}</span>
        <span onClick={() => removeTag(item)} className={"fe-x"} />
      </li>
    );
  });

  const SortableList = SortableContainer(({ items }) => {
    return (
      <ul className={styles.list}>
        {items.map((item, index) => {
          return (
            <SortableItem key={`item-${index}`} index={index} item={item} />
          );
        })}
      </ul>
    );
  });

  return (
    <div style={{ position: "relative" }}>
      <SortableList
        pressDelay={100}
        items={items}
        axis={"xy"}
        onSortEnd={({ oldIndex, newIndex, collection, isKeySorting }) => {
          const _value = [...items];
          const el = _value[oldIndex];
          _value.splice(oldIndex, 1);
          _value.splice(newIndex, 0, el);
          setItems(_value);
          onChange(_value);
        }}
      />
      <input
        type={"text"}
        value={q}
        className={inputClass.join(" ")}
        onKeyDown={(e) => e.key === "Enter" && addWord()}
        onChange={(e) => searchTag(e.target.value)}
      />
      {find.length > 0 && (
        <ul className={styles.dropDown}>
          {find.map((item, index) => {
            return (
              <li onClick={() => addTag(item)} key={`find-${index}`}>
                {item.text}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
